import styled from 'styled-components';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Wrapper as AssetWrapper } from '../Item/Item.styles';

interface WrapperProps {
  isUnassigned?: boolean;
}

export const Wrapper = styled(Box)<WrapperProps>(({ theme, isUnassigned }) => ({
  width: '100%',

  [AssetWrapper]: {
    background: theme.colors.bg,
  },

  '&:nth-child(odd)': {
    [AssetWrapper]: {
      background: isUnassigned ? theme.colors.bg : theme.colors.neutral['100'],
    },
  },
}));
